/* HADELE: Card quick-add — round bag button + slide-up size picker on product cards, matching Complete the Look. Self-contained: injects its own CSS + buttons, fetches sizes on demand, adds to cart via the theme's own cart-drawer render mechanism so the cart updates live. */
(function(){
  if(window.__hdCardQA){return;} window.__hdCardQA=true;

  var CSS=[
    'card-product > .relative{position:relative;}',
    '.hd-cqa{position:absolute;inset:0;pointer-events:none;z-index:4;}',
    '.hd-cqa__bag{position:absolute;right:10px;bottom:10px;width:34px;height:34px;display:flex;align-items:center;justify-content:center;border:none;border-radius:50%;background:#fff;color:rgb(var(--color-heading-text));box-shadow:0 2px 8px rgba(40,34,28,.18);cursor:pointer;pointer-events:auto;padding:0;transition:transform .2s ease,background .2s ease,color .2s ease;}',
    '.hd-cqa__bag:hover{transform:scale(1.08);background:rgb(var(--color-heading-text));color:#fff;}',
    '.hd-cqa__bag svg{width:15px;height:15px;}',
    '.hd-cqa__panel{position:absolute;inset:auto 0 0 0;background:rgba(255,255,255,.97);-webkit-backdrop-filter:blur(2px);backdrop-filter:blur(2px);padding:12px 12px 14px;transform:translateY(102%);transition:transform .28s cubic-bezier(.22,.61,.36,1);pointer-events:auto;}',
    '.hd-cqa.is-open .hd-cqa__panel{transform:translateY(0);}',
    '.hd-cqa.is-open .hd-cqa__bag{opacity:0;pointer-events:none;}',
    '.hd-cqa__close{position:absolute;top:4px;right:8px;border:none;background:none;font-size:18px;line-height:1;cursor:pointer;color:#888;padding:0;}',
    '.hd-cqa__label{font-size:9px;letter-spacing:.16em;text-transform:uppercase;opacity:.6;margin:2px 0 9px;text-align:center;}',
    '.hd-cqa__sizes{display:flex;flex-wrap:wrap;gap:5px;justify-content:center;}',
    '.hd-cqa__size{min-width:30px;padding:6px 7px;font-size:11px;border:1px solid rgba(0,0,0,.18);border-radius:999px;background:transparent;color:inherit;cursor:pointer;font-family:inherit;transition:background .15s,color .15s,border-color .15s;}',
    '.hd-cqa__size:hover:not([disabled]){background:rgb(var(--color-heading-text));color:#fff;border-color:rgb(var(--color-heading-text));}',
    '.hd-cqa__size[disabled]{opacity:.35;cursor:default;text-decoration:line-through;}',
    '.hd-cqa__size.is-added{background:rgb(var(--color-heading-text));color:#fff;border-color:rgb(var(--color-heading-text));}'
  ].join('');

  function injectCSS(){ if(document.getElementById('hd-cqa-css')){return;} var s=document.createElement('style'); s.id='hd-cqa-css'; s.textContent=CSS; document.head.appendChild(s); }

  var BAG='<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 8h12l-1 12H7L6 8z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/><line x1="12" y1="12" x2="12" y2="16"/><line x1="10" y1="14" x2="14" y2="14"/></svg>';

  function eligible(card){
    if(card.__hdcqa){return false;}
    if(card.classList.contains('predictive-search__card-product')){return false;}
    if(card.closest('.predictive-search')){return false;}
    if(card.closest('[data-hd-ctl]')){return false;}
    if(card.classList.contains('disabled')){return false;}
    return true;
  }

  function injectButtons(){
    document.querySelectorAll('card-product').forEach(function(card){
      if(!eligible(card)){return;}
      var media=card.querySelector('.relative'); if(!media){return;}
      var handle=card.getAttribute('data-handle'); if(!handle){return;}
      card.__hdcqa=true;
      var wrap=document.createElement('div'); wrap.className='hd-cqa'; wrap.setAttribute('data-handle',handle);
      var bag=document.createElement('button'); bag.type='button'; bag.className='hd-cqa__bag'; bag.setAttribute('aria-label','Quick add'); bag.setAttribute('aria-expanded','false'); bag.innerHTML=BAG;
      wrap.appendChild(bag); media.appendChild(wrap);
    });
  }

  function closeAll(except){ document.querySelectorAll('.hd-cqa.is-open').forEach(function(w){ if(w!==except){ w.classList.remove('is-open'); var b=w.querySelector('.hd-cqa__bag'); if(b){b.setAttribute('aria-expanded','false');} } }); }

  function fallbackCount(){
    fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(cart){
      document.querySelectorAll('[data-cart-count],.cart-count,.cart-count-bubble,.header__cart-count').forEach(function(el){ el.textContent=cart.item_count; });
    }).catch(function(){});
  }

  function addToCart(id,btn){
    if(!id){return;}
    var original=btn?btn.innerHTML:''; if(btn){btn.disabled=true;}
    var drawer=document.querySelector('cart-drawer');
    var fd=new FormData();
    fd.append('id',id);
    fd.append('quantity',1);
    if(drawer&&typeof drawer.getSectionsToRender==='function'){
      try{ fd.append('sections',drawer.getSectionsToRender().map(function(s){return s.section;}).join(',')); }catch(e){}
      fd.append('sections_url',window.location.pathname);
    }
    fetch((window.routes&&window.routes.cart_add_url)||'/cart/add',{method:'POST',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:fd})
      .then(function(r){return r.json();})
      .then(function(res){
        if(res&&res.status){throw new Error('err');}
        if(btn){ btn.classList.add('is-added'); btn.innerHTML='\u2713'; }
        var monsterActive=!!document.querySelector('script[src*="/cart_renderer"]');
        if(drawer&&typeof drawer.renderContents==='function'&&res.sections){
          try{ drawer.renderContents(res,!monsterActive); }catch(e){ fallbackCount(); }
        } else { fallbackCount(); }
        document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
        document.dispatchEvent(new CustomEvent('cart:build',{bubbles:true}));
        setTimeout(function(){ if(btn){ btn.classList.remove('is-added'); btn.innerHTML=original; btn.disabled=false; } var w=btn&&btn.closest('.hd-cqa'); if(w){ w.classList.remove('is-open'); var bg=w.querySelector('.hd-cqa__bag'); if(bg){bg.setAttribute('aria-expanded','false');} } },1400);
      })
      .catch(function(){ if(btn){ btn.innerHTML='\u2715'; setTimeout(function(){ btn.innerHTML=original; btn.disabled=false; },1400); } });
  }

  function loadPanel(wrap){
    if(wrap.__loaded){return Promise.resolve();}
    var handle=wrap.getAttribute('data-handle');
    return fetch('/products/'+handle+'.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(p){
      wrap.__loaded=true;
      var variants=p.variants||[];
      var bag=wrap.querySelector('.hd-cqa__bag');
      if(variants.length<=1){ if(bag){ bag.classList.add('hd-cqa__bag--direct'); if(variants[0]){ bag.setAttribute('data-variant',variants[0].id); } } return; }
      var panel=document.createElement('div'); panel.className='hd-cqa__panel';
      var close=document.createElement('button'); close.type='button'; close.className='hd-cqa__close'; close.setAttribute('aria-label','Close'); close.innerHTML='&times;';
      var label=document.createElement('p'); label.className='hd-cqa__label'; label.textContent='Select size';
      var sizes=document.createElement('div'); sizes.className='hd-cqa__sizes';
      variants.forEach(function(v){ var b=document.createElement('button'); b.type='button'; b.className='hd-cqa__size'; b.setAttribute('data-variant',v.id); b.textContent=(v.option1||v.title); if(!v.available){ b.setAttribute('disabled','disabled'); b.setAttribute('aria-disabled','true'); } sizes.appendChild(b); });
      panel.appendChild(close); panel.appendChild(label); panel.appendChild(sizes); wrap.appendChild(panel);
    }).catch(function(){ wrap.__loaded=false; });
  }

  document.addEventListener('click',function(e){
    var bag=e.target.closest('.hd-cqa__bag');
    if(bag){
      e.preventDefault(); e.stopPropagation();
      var wrap=bag.closest('.hd-cqa');
      if(bag.classList.contains('hd-cqa__bag--direct')){ addToCart(bag.getAttribute('data-variant'),bag); return; }
      if(!wrap.__loaded){ loadPanel(wrap).then(function(){ var b=wrap.querySelector('.hd-cqa__bag'); if(b.classList.contains('hd-cqa__bag--direct')){ addToCart(b.getAttribute('data-variant'),b); return; } closeAll(wrap); wrap.classList.add('is-open'); b.setAttribute('aria-expanded','true'); }); return; }
      var open=wrap.classList.contains('is-open'); closeAll(wrap); wrap.classList.toggle('is-open',!open); bag.setAttribute('aria-expanded',String(!open)); return;
    }
    var close=e.target.closest('.hd-cqa__close');
    if(close){ e.preventDefault(); e.stopPropagation(); var w=close.closest('.hd-cqa'); if(w){ w.classList.remove('is-open'); var b=w.querySelector('.hd-cqa__bag'); if(b){b.setAttribute('aria-expanded','false');} } return; }
    var size=e.target.closest('.hd-cqa__size');
    if(size){ e.preventDefault(); e.stopPropagation(); if(size.hasAttribute('disabled')){return;} addToCart(size.getAttribute('data-variant'),size); return; }
    if(!e.target.closest('.hd-cqa')){ closeAll(null); }
  });

  function init(){ injectCSS(); injectButtons(); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',init); } else { init(); }
  document.addEventListener('shopify:section:load',init);
  try{ var mo=new MutationObserver(function(muts){ var add=false; muts.forEach(function(m){ if(m.addedNodes&&m.addedNodes.length){add=true;} }); if(add){ injectButtons(); } }); mo.observe(document.body,{childList:true,subtree:true}); }catch(e){}
})();
